import UsaLayout from "./layout/USALayout";
import IndustriesHeader from "./USA-Components/IndustriesHeader";
import IndustriesData from "./USA-Components/IndustriesData";
import WhyPartner from "./USA-Components/WhyPartner";
const USIndustries = () => {
    return (
        <UsaLayout>
            <>
                <IndustriesHeader/>
                <IndustriesData/>
                <WhyPartner/>
            </>
        </UsaLayout>
    )
}

export default USIndustries
;